import React from 'react'

import {
  classnames,
} from '@cgtrader/triangle-ui/dist/src/ssr-index'
import { object, string, number, bool, oneOf } from 'prop-types'

import AdArea from 'Pods/NewDownloadItemPage/Components/AdArea'

import ProductGridArea from './Components/ProductGridArea/ProductGridArea'
import { alsoBoughtAreaMock } from './Mocks/alsoBoughtAreaMock'
import { moreSellerItemsMock } from './Mocks/moreSellerItemsMock'
import { similarItemsAreaMock } from './Mocks/similarItemsAreaMock'

function BottomSection({
  similarItemsArea = { products: [] },
  alsoBoughtArea = { products: [] },
  moreSellerItems = { products: [] },
  productId,
  productType,
  authorName,
  extractingCoreStyles = false,
  bottomSectionLayout = null,
  isActiveSubscriber = false,
}) {
  const similarItemsAreaData = extractingCoreStyles ? similarItemsAreaMock : similarItemsArea
  const alsoBoughtAreaData = extractingCoreStyles ? alsoBoughtAreaMock : alsoBoughtArea
  const moreSellerItemsData = extractingCoreStyles ? moreSellerItemsMock : moreSellerItems

  const hasAlsoBoughtProducts = alsoBoughtAreaData?.products.length > 0
  const hasSimilarItems = similarItemsAreaData?.products.length > 0
  const hasMoreSellerItems = moreSellerItemsData?.products.length > 0
  const isDownloadLayout = bottomSectionLayout === 'download'
  const shouldRenderAdArea = isDownloadLayout && !isActiveSubscriber

  if (!hasAlsoBoughtProducts && !hasSimilarItems && !hasMoreSellerItems) {
    return null
  }

  const conditionalLayoutClass = (() => {
    if (hasSimilarItems && !hasAlsoBoughtProducts && !hasMoreSellerItems) {
      return 'similar-items-area-only'
    }

    if (!hasSimilarItems && !hasAlsoBoughtProducts && hasMoreSellerItems) {
      return 'more-items-area-only'
    }

    if (hasSimilarItems && !hasAlsoBoughtProducts && hasMoreSellerItems) {
      return 'similar-items-area-and-more-items-area'
    }

    return ''
  })()

  const productTypeUrl = productType === 'printable' ? '3d-print-models' : '3d-models'

  return (
    <div className={classnames(
      'item-page__footer',
      'product-grid-area__full-row',
      conditionalLayoutClass,
      bottomSectionLayout === 'download' && 'bottom-section--download',
    )}>
      {hasMoreSellerItems && (
        <ProductGridArea
          {...moreSellerItemsData}
          title={`More from ${authorName}`}
          className="more-items-area"
          withViewAllButton
          href={`/${productTypeUrl}?author=${authorName}`}
          extractingCoreStyles={extractingCoreStyles}
          ariaLabel="View all models from this designer"
        />
      )}
      {hasAlsoBoughtProducts && (
        <ProductGridArea
          {...alsoBoughtAreaData}
          title="Models often bought together"
          className="also-bought-area"
          extractingCoreStyles={extractingCoreStyles}
          ariaLabel="View all models often bought together"
        />
      )}
      {hasSimilarItems && (
        <ProductGridArea
          {...similarItemsAreaData}
          withViewAllButton
          className="similar-items-area"
          title="Visually similar models"
          href={`/${productTypeUrl}?similar_model_id=${productId}`}
          extractingCoreStyles={extractingCoreStyles}
          ariaLabel="View all visually similar models"
        />
      )}
      {shouldRenderAdArea && (
        <AdArea
          className="bottom-section-ad desktop-only-ad"
          id="new-download-bottom-section-ad"
          zoneName="hrec_2"
        />
      )}
    </div>
  )
}

BottomSection.propTypes = {
  similarItemsArea: object,
  alsoBoughtArea: object,
  moreSellerItems: object,
  productId: number.isRequired,
  productType: string.isRequired,
  authorName: string.isRequired,
  extractingCoreStyles: bool,
  bottomSectionLayout: oneOf(['download', null]),
  isActiveSubscriber: bool,
}

export default BottomSection
